/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getPaymentProductInformation} from '../api'

 export const useQueryGetPaymentProductInformation = createReactQueryHook('getPaymentProductInformation', getPaymentProductInformation)
